module.exports = __webpack_public_path__ + "img/Silver Lake.1212a94.png";